import { graphql } from 'gatsby';
import BlogPostsPagination from '../templates/blog-posts-pagination';

export default BlogPostsPagination;

export const blogPostsQuery = graphql`
  query blogPostsQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD.MM.YYYY")
            title
            categories
          }
        }
      }
    }
  }
`;
